import React, { useState } from "react";
import { UsernameContainer, UsernameWrapper } from "./style";
import { InputDiv } from "../../../reuseableComp.tsx/InputWithLogo";
import { Button } from "../../../reuseableComp.tsx/Button";
import axios from "axios";
import { Error } from "../../Signup/style";
import { Dna } from "react-loader-spinner";
import { LittleSpace } from "../AddNames/style";

interface Close {
  closeFunc: () => void;
}

const UsernameModal = ({ closeFunc }: Close) => {
  const [userName, setUsername] = useState("");
  const [loading, setLoading] = useState(false);
  const storedToken = sessionStorage.getItem("token");
  const token = `Bearer ${storedToken}`;
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const Authorization = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  const payload = {
    userName: userName,
  };

  const handleAddUsername = async () => {
    setLoading(true);

    axios
      .put(`${process.env.REACT_APP_API_BASE_ENDPOINT}/username`, payload, {
        headers: Authorization,
      })
      .then((res: any) => {
        setSuccess(res.data.message);
        setLoading(false);
        setTimeout(() => {
          closeFunc();
        }, 4000);
      })
      .catch((err) => {
        setError(err.response.data.message);
        setLoading(false);
        setTimeout(() => {
          setError("");
        }, 3000);
      });
  };
  return (
    <UsernameContainer>
      <UsernameWrapper>
        <h2>Add Your Username</h2>
        <p>Users without a username are unverified, Add a unique username. </p>
        <InputDiv>
          <div>icon</div>
          <div>
            <input
              type="text"
              placeholder="Enter Username"
              required
              value={userName}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
        </InputDiv>
        <br />

        {success && (
          <>
            <LittleSpace>
              <Error>
                <span>{success}</span>
              </Error>
            </LittleSpace>
          </>
        )}

        {error && (
          <>
            <LittleSpace>
              <Error>
                <p>{error}</p>
              </Error>
            </LittleSpace>
          </>
        )}
        <Button onClick={handleAddUsername}>
          {loading ? (
            <>
              <Dna
                visible={true}
                height="50"
                width="80"
                ariaLabel="dna-loading"
                wrapperStyle={{}}
                wrapperClass="dna-wrapper"
              />
            </>
          ) : (
            <>Set Username</>
          )}
        </Button>
      </UsernameWrapper>
    </UsernameContainer>
  );
};
export default UsernameModal;
